<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col>
        <h2 class="mb-3">
          <MyIncidentIcon v-if="iconSrc" :icon="iconSrc"></MyIncidentIcon>
          <div class="pull-left">{{ details.title }}</div>
          <div class="clearfix"></div>
        </h2>
        <div class="mb-1">
          <span class="application-heading">Incident Date:</span>
          {{ details.incidentDate }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Category:</span>
          {{ details.category }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Description:</span>
          {{ details.description }}
        </div>
        <div class="mb-1 countries-list">
          <span class="application-heading">Country:</span>
          <DetailsListItemCountryChip
            v-if="
              details.country.iso2Code &&
              details.country.name &&
              details.country.flagUrl
            "
            :key="details.country.countryAlpha2Code"
            :name="details.country.name"
            :code="details.country.iso2Code.toUpperCase()"
            :flagUrl="details.country.flagUrl"
            theme="dark"
          ></DetailsListItemCountryChip>
        </div>
        <div class="mb-1">
          <span class="application-heading">Created:</span>
          {{ details.createdAt }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Updated:</span>
          {{ details.updatedAt }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MODULE_PREFIX_HOME } from "@/store";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";
import DetailsListItemCountryChip from "@/components/common/details/DetailsListItemCountryChip.vue";

export default {
  name: "MyIncidentsDetails",
  components: {
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
    MyIncidentIcon: () => import("@/components/myIncidents/MyIncidentIcon"),
  },
  data: () => ({
    id: null,
    details: {
      title: null,
      incidentDate: null,
      category: null,
      description: null,
      country: {
        iso2Code: null,
        name: null,
        flagUrl: null,
      },
      createdAt: null,
      updatedAt: null,
    },
  }),
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    iconSrc() {
      return this.details?.category?.toLowerCase();
    },
  },
  mounted() {
    if (
      this.detailsSidebar.selected === DETAIL_SIDEBAR_TYPES.myIncidents &&
      lodashGet(this.detailsSidebar, "features[0].properties.gid")
    ) {
      let properties = this.detailsSidebar.features[0].properties;
      this.details = {
        title: properties.title,
        description: properties.description,
        category: properties.category,
        country: {
          iso2Code: properties.country_iso2_code,
          name: properties.country_name,
          flagUrl: properties.flag_url,
        },
        incidentDate: new Date(properties.incident_date).toLocaleDateString(),
        createdAt: new Date(properties.created_at).toLocaleString(),
        updatedAt: new Date(properties.updated_at).toLocaleString(),
      };
    }
  },
};
</script>

<style scoped>
.countries-list {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}
</style>
